import cn from "classnames";
import SimpleDatetime from "components/shared/datetime";
import { utcTimeInOffset } from "helpers/date";
import { bidStatusesEnum, idlenessStatusesEnum } from "helpers/enums";
import { requiredField } from "helpers/validators";
import moment from "moment";
import React from "react";

const PlanEnterDate = (props) => {
    const {
        i,
        isDisabled,
        planEnterDate,
        secondaryPlanEnterDate,
        onChange,
        utcTimezone,
        carStatus,
        bidStatus,
        couplingDates,
        config,
    } = props;
    const errorText = () => {
        const errors = [];
        const momentTime = moment(utcTimezone ? utcTimeInOffset(planEnterDate, utcTimezone) : planEnterDate);
        if (
            i === 0 &&
            carStatus &&
            ((bidStatus && bidStatus === bidStatusesEnum.New) || !bidStatus) &&
            carStatus.status === idlenessStatusesEnum.Busy &&
            momentTime < moment(carStatus.releaseDate)
        ) {
            errors.push("Дата заявки меньше даты освобождения машины");
        }
        if (
            couplingDates &&
            couplingDates.startedAt &&
            i === 0 &&
            (momentTime < moment(couplingDates.startedAt) ||
                (couplingDates.endedAt && momentTime > moment(couplingDates.endedAt)))
        ) {
            errors.push("Плановая дата заявки не подходит под выбранную смену. Измените смену.");
        }
        if (errors.length > 0) {
            return (
                <div className="mt-1 field-wrap__error d-block">
                    {errors.map((item, i) => (
                        <div key={i}>{item}</div>
                    ))}
                </div>
            );
        } else {
            return null;
        }
    };

    const toggleSecondaryPlanEnterDate = () => {
        const value = secondaryPlanEnterDate ? null : planEnterDate;
        onChange({ name: "secondaryPlanEnterDate", value });
    };

    return (
        <div className="row form-group">
            <label className="col-sm-4 col-md-3 col-form-label col-form-label-sm text-md-right text-sm-left field-wrap__label--required">
                Дата прибытия
            </label>
            <div className="col-sm-8 col-md-9">
                <div className="row">
                    <div className="col-auto">
                        <SimpleDatetime
                            inPortal
                            wrapper="date-filter"
                            inputProps={{
                                name: "planEnterDate",
                                type: "datetime",
                            }}
                            libOptions={{
                                disabled: isDisabled,
                            }}
                            index={i}
                            onChange={onChange}
                            value={planEnterDate}
                            validators={[requiredField]}
                        />
                    </div>
                    {config.secondaryPlanEnterDate &&
                        !config.secondaryPlanEnterDate.isHidden &&
                        secondaryPlanEnterDate && (
                            <>
                                <div className="col-auto col-form-label col-form-label-sm text-center px-0">
                                    &mdash;
                                </div>
                                <div className="col-auto">
                                    <SimpleDatetime
                                        inPortal
                                        wrapper="date-filter"
                                        inputProps={{
                                            name: "secondaryPlanEnterDate",
                                            type: "datetime",
                                        }}
                                        libOptions={{
                                            disabled: isDisabled,
                                        }}
                                        index={i}
                                        onChange={onChange}
                                        value={secondaryPlanEnterDate}
                                    />
                                </div>
                            </>
                        )}
                    {utcTimezone && (
                        <span className="col-auto col-form-label col-form-label-sm pl-0">{utcTimezone}</span>
                    )}
                </div>
                {errorText()}
                {config.secondaryPlanEnterDate && !config.secondaryPlanEnterDate.isHidden && (
                    <div className="col-form-label-sm d-inline-block" onClick={toggleSecondaryPlanEnterDate}>
                        <div
                            className={cn("checkbox d-inline-block", { "checkbox--checked": secondaryPlanEnterDate })}
                        />
                        &nbsp;
                        <div className="d-inline-block checkbox__text">Диапазон дат</div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PlanEnterDate;
